// extracted by mini-css-extract-plugin
export var lg = "_22-4";
export var md = "_22-3";
export var sm = "_22-2";
export var xs = "_22-1";
export var xxs = "_22-0";